import bridge from '@/utils/bridge';
import { dispatch } from '@/store';
import { getCounter } from './utilities';

function getSessionId(ownerGuid) {
  return `session_${ownerGuid}@go.to`;
}

function getOwnerGuid(sessionId) {
  const match = sessionId.match(/session_(.*)@go.to/);
  return match && match[1];
}

function setAllAppsInStore(ownerGuid, appList) {
  dispatch({
    type: 'APP_LIST_PROXY',
    payload: appList,
    ownerGuid,
  });
}

async function getAllApps(ownerGuid) {
  const appList = await bridge.ask('DikeController', 'getAllApps', [
    getSessionId(ownerGuid),
  ]);
  setAllAppsInStore(ownerGuid, appList);
}

function setBadgesInStore(ownerGuid, badges) {
  dispatch({
    type: 'APP_LIST_BADGES',
    payload: badges,
    ownerGuid,
  });
}

async function getAllBadges(ownerGuid) {
  const badges = await bridge.ask('DikeController', 'getAllBadges', [
    getSessionId(ownerGuid),
  ]);
  setBadgesInStore(ownerGuid, badges);
}

class DikeProxy {
  counter = getCounter();

  subscribedIds = {};

  subscribedGuids = {};

  constructor() {
    bridge.subscribe('hydra/dike/apps/refreshed', sessionId => {
      const ownerGuid = getOwnerGuid(sessionId);
      if (
        this.subscribedIds[ownerGuid] &&
        this.subscribedIds[ownerGuid].length
      ) {
        getAllApps(ownerGuid);
      }
    });
    bridge.subscribe('hydra/dike/badges/refreshed', sessionId => {
      const ownerGuid = getOwnerGuid(sessionId);
      if (
        this.subscribedIds[ownerGuid] &&
        this.subscribedIds[ownerGuid].length
      ) {
        getAllBadges(ownerGuid);
      }
    });
  }

  _subscribe(ownerGuid, setId) {
    if (this.subscribedGuids[setId] === ownerGuid) {
      return;
    }
    this._unsubscribe(setId);
    if (!this.subscribedIds[ownerGuid]) {
      this.subscribedIds[ownerGuid] = [];
    }
    this.subscribedGuids[setId] = ownerGuid;
    if (this.subscribedIds[ownerGuid].length === 0) {
      getAllApps(ownerGuid);
    }
    this.subscribedIds[ownerGuid].push(setId);
  }

  subscribe(ownerGuid) {
    const setId = this.counter.next().value;
    this._subscribe(ownerGuid, setId);
    return {
      unsubscribe: this._unsubscribe.bind(this, setId),
      update: updatedOwnerGuid => this._subscribe(updatedOwnerGuid, setId),
    };
  }

  _unsubscribe(setId) {
    if (!setId) {
      return;
    }
    const ownerGuid = this.subscribedGuids[setId];
    const subscriptions = this.subscribedIds[ownerGuid];
    if (subscriptions) {
      if (subscriptions.length > 0) {
        const idx = subscriptions.indexOf(setId);
        subscriptions.splice(idx, 1);
      }
      if (subscriptions.length < 1) {
        setAllAppsInStore(ownerGuid, undefined);
      }
    }
    this.subscribedGuids[setId] = null;
  }
}

export default new DikeProxy();



// WEBPACK FOOTER //
// ./src/Proxies/DikeProxy.js